export function bookedNotificationText(count: number, accountLabel: string): string {
    return `${count} ${count === 1 ? "boeking" : "boekingen"} verplaatst naar ${accountLabel}.`;
}

export function bookedTaskMessage(count: number, accountCode: string, accountLabel: string): string {
    return bookedNotificationText(count, `${accountCode} ${accountLabel}`);
}
